module.exports = __webpack_public_path__ + "img/attachment_icon.28887d75.png";